import React, { useEffect, useState } from 'react';
import { Checkbox, Menu, MenuItem } from '@mui/material';
import { format, parseISO } from 'date-fns';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import more from '../../Assets/images/more.svg';
import ButtonPlus from '../SelectValue/ButtonPlus';
import Loading from '../SelectValue/Loading';
import getServices from '../../Services/get-service';
import AddAdmin from './AddAdmin';
import ChangeRole from './ChangeRole';
import DeActivateModal from './DeActiviteModal';

export default function UserTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [email, setEmail] = useState('');
  const [user, setUsers] = useState([]);
  const [id, setId] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpen1 = (email) => {
    setOpen1(true);
    setEmail(email);
  };
  const handleClose1 = () => setOpen1(false);
  const handleOpen2 = (id, status) => {
    setOpen2(true);
    setId(id);
    setStatus(status);
  };
  const handleClose2 = () => setOpen2(false);

  const handleOpenMenu = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };

  const handleChangePage = () => {
    if (page < Math.ceil(user.length / rowsPerPage) - 1) {
      setPage(page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  useEffect(() => {
    setLoading(true);
    getServices.getAdminUsers().then(
      (response) => {
        setLoading(false);
        if (response.data.status === '2000') {
          setUsers(response.data.data.reverse());
          console.log(response.data.data);
        }
      },
      (error) => {
        setLoading(false);
      }
    );
  }, []);

  const indexOfLastUser = (page + 1) * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const currentUsers = user.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(user.length / rowsPerPage);

  return (
    <>
      <AddAdmin open={open} handleClose={handleClose} />
      <ChangeRole open={open1} handleClose={handleClose1} email={email} />
      <DeActivateModal open={open2} handleClose={handleClose2} id={id} status={status} />
      <Loading open={loading} />

      <div className="mb-5 flex justify-between">
        <ButtonPlus name="Add admin user" onClick={handleOpen} />
      </div>

      <div className="mt-16 mb-10">
        <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
          <Checkbox />
          <p className="text-text flex-1 text-center whitespace-normal break-words">First Name</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Last Name</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Email Address</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Phone Number</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Role</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Date Created</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Account Status</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Action</p>
        </div>

        {loading ? (
          <div>
            {[...Array(rowsPerPage)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
              >
                <div className="w-6 md:w-[5%]">
                  <Skeleton width={24} height={24} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="80%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width={24} height={24} className="mx-auto" />
                </div>
              </div>
            ))}
          </div>
        ) : user.length === 0 ? (
          <div className="text-center p-4 text-gray-500">
            No users found.
          </div>
        ) : (
          <>
            <div className="md:hidden">
              {currentUsers.map((row, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
                >
                  <p className="font-semibold capitalize">{row.firstName}</p>
                  <p><b>Last Name:</b> {row.lastName}</p>
                  <p><b>Email:</b> {row.emailAddress}</p>
                  <p><b>Phone:</b> {row.phoneNumber}</p>
                  <p><b>Role:</b> {row.userRole}</p>
                  <p>
                    <b>Date Created:</b>{' '}
                    {row.dateCreated ? format(parseISO(row.dateCreated), 'MMM d yyyy') : 'No date'}
                  </p>
                  <p>
                    <b>Status:</b>{' '}
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-white text-sm font-medium ${
                        row.status === 'active' 
                          ? 'bg-green-700' 
                          : row.status === 'inactive' 
                          ? 'bg-red-700' 
                          : 'bg-gray-700'
                      }`}
                    >
                      {row.status || 'Unknown'}
                    </span>
                  </p>
                  <div className="flex justify-end mt-2">
                    <img
                      src={more}
                      alt="More options"
                      className="cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, row.id)}
                    />
                  </div>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedUserId === row.id}
                    onClose={handleCloseMenu}
                    sx={{ '& .MuiPaper-root': { boxShadow: 'none' } }}
                  >
                    <MenuItem onClick={() => handleOpen1(row.emailAddress)}>
                      Change Role
                    </MenuItem>
                    {row.status === 'active' ? (
                      <MenuItem
                        onClick={() => handleOpen2(row.id, 'de')}
                        sx={{ color: '#ef4444' }}
                      >
                        Deactivate User
                      </MenuItem>
                    ) : (
                      <MenuItem
                        onClick={() => handleOpen2(row.id, 'acti')}
                        sx={{ color: '#10b981' }}
                      >
                        Activate User
                      </MenuItem>
                    )}
                  </Menu>
                </div>
              ))}
            </div>
            <div className="hidden md:block">
              {currentUsers.map((row, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
                >
                  <Checkbox />
                  <div className="flex-1 text-center capitalize break-words whitespace-normal min-w-0 px-1">
                    {row.firstName}
                  </div>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {row.lastName}
                  </div>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {row.emailAddress}
                  </div>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {row.phoneNumber}
                  </div>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {row.userRole}
                  </div>
                  <div className="flex-1 text-center text-primary-color break-words whitespace-normal min-w-0 px-1">
                    {row.dateCreated ? format(parseISO(row.dateCreated), 'MMM d yyyy') : 'No date'}
                  </div>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {/* <span
                      className={`inline-block px-3 py-1 rounded-full text-white text-sm font-medium ${
                        row.status === 'active'
                          ? 'bg-green-700'
                          : row.status === 'inactive'
                          ? 'bg-red-700'
                          : 'bg-gray-700'
                      }`}
                    >
                      {row.status || 'Unknown'}
                    </span> */}
                    {row.status === "active" ? <span className=' rounded-[32px] p-3 bg-green-700 text-white'>Active</span> : <span className=' rounded-[32px] p-3 bg-red-700 text-white'>Inactive</span>}
                  </div>
                  <div className="flex-1 text-center">
                    <img
                      src={more}
                      alt="More options"
                      className="mx-auto cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, row.id)}
                    />
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && selectedUserId === row.id}
                      onClose={handleCloseMenu}
                      sx={{ '& .MuiPaper-root': { boxShadow: 'none' } }}
                    >
                      <MenuItem onClick={() => handleOpen1(row.emailAddress)}>
                        Change Role
                      </MenuItem>
                      {row.status === 'active' ? (
                        <MenuItem
                          onClick={() => handleOpen2(row.id, 'de')}
                          sx={{ color: '#ef4444' }}
                        >
                          Deactivate User
                        </MenuItem>
                      ) : (
                        <MenuItem
                          onClick={() => handleOpen2(row.id, 'acti')}
                          sx={{ color: '#10b981' }}
                        >
                          Activate User
                        </MenuItem>
                      )}
                    </Menu>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {totalPages > 1 && (
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 mb-10">
            <button
              onClick={handlePreviousPage}
              disabled={page === 0}
              className={`px-4 py-2 rounded-lg ${
                page === 0
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Previous
            </button>
            <p className="text-text text-sm sm:text-base">
              Page {page + 1} of {totalPages}
            </p>
            <button
              onClick={handleChangePage}
              disabled={page === totalPages - 1}
              className={`px-4 py-2 rounded-lg ${
                page === totalPages - 1
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
}
